import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import Fila from "./tabla/Fila";

class Tabla extends Component {
  render() {
    return (
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell content="Nombre" />
            <Table.HeaderCell content="Apellidos" />
            <Table.HeaderCell content="Fecha Baja" />
            <Table.HeaderCell content="Colegio" />
            <Table.HeaderCell content="Actividad" />
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {this.props.bajas.map(baja => <Fila key={baja.idBaja} baja={baja} />)}
        </Table.Body>
      </Table>
    );
  }
}
export default Tabla;



// WEBPACK FOOTER //
// ./src/pages/listados/listadoBajas/Tabla.jsx